/**
 * Mobile DPR — Round 3 Deviations Fix (Item 4).
 *
 * Replaces the old legacy 5-step wizard (single-shot form that only wrote
 * the Execution section) with the SAME web-console UI used on desktop:
 * department tiles, per-department locks, and per-section save. This is
 * the only way every department (Quality, Safety, Stores, ...) can submit
 * their own section from a phone, not just Execution.
 *
 * One shared component, one API path — no separate mobile-only endpoints.
 * Offline support (see shared editors' saveSection/postSection + lib/offlineQueue)
 * is unchanged: a save made with no signal queues against the exact same
 * per-section endpoint and replays automatically once back online.
 */
import React from 'react';
import { DprDailyConsole } from '../DPR';

export default function MobileDPR() {
  return (
    <div className="px-3 py-4" data-testid="mobile-dpr-page">
      <DprDailyConsole />
    </div>
  );
}
